import { render, staticRenderFns } from "./ChangeRole.vue?vue&type=template&id=55077fcf&scoped=true&"
import script from "./ChangeRole.vue?vue&type=script&lang=js&"
export * from "./ChangeRole.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRole.vue?vue&type=style&index=0&id=55077fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55077fcf",
  null
  
)

export default component.exports